export default __webpack_public_path__ + "static/media/portfolio.ce2ba80d.png";